import { render, staticRenderFns } from "./dynamicManage.vue?vue&type=template&id=4f89fcc9&scoped=true"
import script from "./dynamicManage.vue?vue&type=script&lang=ts"
export * from "./dynamicManage.vue?vue&type=script&lang=ts"
import style0 from "./dynamicManage.vue?vue&type=style&index=0&id=4f89fcc9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f89fcc9",
  null
  
)

export default component.exports